import React, { useMemo } from "react";
import { bool, func } from "prop-types";

import {
  useSelectedJourneySelector,
  useVehicleQuantitySelector,
} from "@redux/reducers/deal";

import { useCurrentFinancingData } from "@hooks/financing/useCurrentFinancingData";

import Modal from "@components/shared/Modal";
import FinanceDisplayBlocks, {
  getDisplayBlocksVariant,
} from "@components/Financing/FinanceDisplayBlocks";
import Typography from "@components/shared/Typography";

import { JOURNEY_TYPE } from "@shared/constants";
import { getParsedLegalMention } from "@shared/v2/lib/getParsedLegalMention";

const FinanceTerms = ({ isOpen, onClose }) => {
  const { financingVACData } = useCurrentFinancingData();
  const journey = useSelectedJourneySelector();
  const quantity = useVehicleQuantitySelector();

  const parsedLegalMentions = useMemo(() => {
    return getParsedLegalMention(financingVACData.legalMention);
  }, [financingVACData.legalMention]);

  if (journey !== JOURNEY_TYPE.VAC || !isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      ariaLabel={financingVACData.financialProductLabel}
      onClose={onClose}
      withCloseIcon
    >
      <h4 className="text-xl font-semibold pb-4">
        {financingVACData.financialProductLabel}
      </h4>
      <FinanceDisplayBlocks
        displayBlocks={financingVACData.displayBlocks}
        variant={getDisplayBlocksVariant(journey)}
        vehicleQuantity={quantity}
      />
      {parsedLegalMentions.map((paragraph, index) => (
        <Typography className="text-sm" key={index}>
          {paragraph}
        </Typography>
      ))}
    </Modal>
  );
};

FinanceTerms.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default FinanceTerms;
